export const formatDisplayDate = (value, locale = "en-US") => {
  if (!value) {
    return "";
  }

  if (/^\d{4}-\d{2}$/.test(value)) {
    const [year, month] = value.split("-").map(Number);
    return new Intl.DateTimeFormat(locale, {
      month: "long",
      year: "numeric",
    }).format(new Date(year, month - 1, 1));
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(year, month - 1, day));
  }

  return value;
};

export const formatSelectedRange = (from, to, locale = "en-US") => {
  if (from && to) {
    return `${formatDisplayDate(from, locale)} → ${formatDisplayDate(to, locale)}`;
  }

  if (from) {
    return `${formatDisplayDate(from, locale)} → ...`;
  }

  return "";
};
